<template lang="pug">
    div
        Row(:gutter="16")
            template(v-for="(data, index) in nginxData")
                Col(:xxl="4" :xl="6" :lg="6" :md="12")
                    Button.TCPListBtn(
                        :shape="$store.getters.getDashboardConfig.isCircleTCPListBtn ? 'circle' : ''" 
                        :style="{'background-color': data.isClicked ? '#296082' : 'white', 'width': '100%', 'text-align': 'left', 'margin': '2px'}" 
                        :ghost="data.isClicked" 
                        @click="clickOrigin(index)" 
                        :disabled="selectedOrigins.length >= 5 && data.isClicked == false"
                    )
                        Row
                            Col.OriginText(span="18")
                                Icon(:color="latencyToColorName(data.avg_latency)" type="ios-radio-button-on" size=16 style="margin: 5px")
                                | {{ data.originHost }}:{{ data.originPort }}
                            Col.floatRight(span="6")
                                Icon(:color="trendDirectionToColorName(data.trendDirection)" :type="trendDirectionToIcons(data.trendDirection)")
                                span(:style="{'color': trendDirectionToColorName(data.trendDirection)}") {{ data.trendPercentage }}%

</template>
<script>
import bus from "@/libs/bus.js";

import { getEdgeChartData } from "@/api/monitor.js";
import { randomDarkColor } from "@/libs/utils";
import { xAxesTimeFormat } from "@/libs/xAxesTimeFormat";

import { latencyToColorName, trendDirectionToColorName, trendDirectionToIcons } from "@/libs/rcmTableFieldsFunction";

export default {
    name: "OriginLatencyTcpList",
    props: {
        groupNames: { type: Array, default: () => [] },
        tags: { type: Array, default: () => [] },
        serviceGroupNames: { type: Array, default: () => [] },
        domains: { type: Array, default: () => [] },
        appProfileNames: { type: Array, default: () => [] },
        tags: { type: Array, default: () => [] },
        origins: { type: Array, default: () => [] },
        originHosts: { type: Array, default: () => [] },
        originPorts: { type: Array, default: () => [] },
        latencyStatusNames: { type: Array, default: () => [] },
        edgeNames: { type: Array, default: () => [] },
        slbNames: { type: Array, default: () => [] },
        dateRange: { type: String, default: "" },
        customTimeRange: { type: Array, default: () => [] },
        healthCheckMode: { type: Array, default: () => [] }
    },
    components: {},
    watch: {
        selectedOrigins: function(newVal, oldVal) {
            this.$emit("input", newVal);
        }
    },
    created() {},
    beforeDestroy() {
        bus.$off("searchChartData");
    },
    data() {
        return {
            spinShow: false,
            nginxData: []
        };
    },
    methods: {
        clickOrigin(index) {
            this.nginxData[index].isClicked = !this.nginxData[index].isClicked;
        },
        getNginxData() {
            this.spinShow = true;

            var chartOptions = {
                chartType: "originLatencyTcpList",
                groupNames: this.queryFilter.groupNames,
                tags: this.queryFilter.tags,
                serviceGroupNames: this.queryFilter.serviceGroupNames,
                domains: this.queryFilter.domains,
                appProfileNames: this.queryFilter.appProfileNames,
                tags: this.queryFilter.tags,
                origins: this.queryFilter.origins,
                originHosts: this.queryFilter.originHosts,
                originPorts: this.queryFilter.originPorts,
                slbNames: this.queryFilter.slbNames,
                edgeNames: this.queryFilter.edgeNames,
                latencyStatusNames: this.queryFilter.latencyStatusNames,
                dateRangeOptions: {
                    index: this.queryFilter.dateRangeOptions.index,
                    customTimeRange: this.queryFilter.dateRangeOptions.customTimeRange
                },
                healthCheckMode: this.healthCheckMode
            };

            return getEdgeChartData(chartOptions);
        },
        latencyToColorName(latency) {
            return latencyToColorName(latency);
        },
        trendDirectionToColorName(direction) {
            return trendDirectionToColorName(direction);
        },
        trendDirectionToIcons(direction) {
            return trendDirectionToIcons(direction);
        },
        mapTrendData(data) {
            let { avg_latency, previous } = data;
            let trendDirection =
                !avg_latency || !previous || avg_latency == previous
                    ? ""
                    : avg_latency < previous
                    ? "positive"
                    : "negative";
            // let trendPercentage = trendDirection ? (((avg_latency - previous) / previous) * 100).toFixed(1) : 0;
            // trendPercentage = Math.abs(trendPercentage);

            let trendPercentage = !trendDirection
                ? 0
                : trendDirection == "positive"
                ? (previous - avg_latency) / previous
                : (avg_latency - previous) / previous;
            trendPercentage = (trendPercentage * 100).toFixed(0);

            data.trendDirection = trendDirection;
            data.trendPercentage = trendPercentage;
            return data;
        }
    },
    mounted() {
        this.getNginxData().then(result => {
            result.data.data = result.data.data.map(e => {
                // {
                //     originHost: "1.225.127.238",
                //     originPort: "443",
                //     avg_latency: 72,
                //     previous: 77.6
                // };
                e.isClicked = false;
                e = this.mapTrendData(e);
                return e;
            });

            this.nginxData = result.data.data;
            this.spinShow = false;
        });
        bus.$on("searchChartData", () => {
            this.getNginxData().then(result => {
                result.data.data = result.data.data.map(e => {
                    e.isClicked = false;
                    e = this.mapTrendData(e);
                    return e;
                });
                this.nginxData = result.data.data;
                this.spinShow = false;
            });
        });
    },
    computed: {
        selectedOrigins() {
            return this.nginxData.filter(e => e.isClicked == true);
        },
        queryFilter() {
            var queryFilter = this.$store.state.dashboard.queryFilter;

            // 如果dashboardQueryFilter組件還沒生成, 那就先看store > queryGroupName
            var queryGroupName = this.$store.state.queryGroupName;
            return {
                groupNames:
                    this.groupNames.length > 0
                        ? this.groupNames
                        : queryGroupName !== "all"
                        ? [queryGroupName]
                        : queryFilter.groupNames,
                tags: this.tags.length > 0 ? this.tags : queryFilter.tags,
                serviceGroupNames:
                    this.serviceGroupNames.length > 0 ? this.serviceGroupNames : queryFilter.serviceGroupNames,
                domains: this.domains.length > 0 ? this.domains : queryFilter.serverNames,
                appProfileNames: this.appProfileNames.length > 0 ? this.appProfileNames : queryFilter.appProfileNames,
                tags: this.tags.length > 0 ? this.tags : queryFilter.tags,
                origins: this.origins.length > 0 ? this.origins : queryFilter.origins,
                originHosts: this.originHosts.length > 0 ? this.originHosts : queryFilter.originHosts,
                originPorts: this.originPorts.length > 0 ? this.originPorts : queryFilter.originPorts,
                slbNames: this.slbNames.length > 0 ? this.slbNames : queryFilter.slbNames,
                edgeNames: this.edgeNames.length > 0 ? this.edgeNames : queryFilter.edgeNames,
                latencyStatusNames:
                    this.latencyStatusNames.length > 0 ? this.latencyStatusNames : queryFilter.latencyStatusNames,
                dateRangeOptions: {
                    index: this.dateRange || queryFilter.dateRangeOptions.index,
                    customTimeRange:
                        this.customTimeRange.length > 0 ? customTimeRange : queryFilter.dateRangeOptions.customTimeRange
                }
            };
        }
    }
};
</script>
<style>
.TCPListBtn > span {
    width: 100%;
}
.TCPListBtn {
    padding: 0 10px;
}
.OriginText {
    text-overflow: ellipsis;
    overflow: hidden;
}
.floatRight {
    text-align: right;
    font-size: 12px;
    padding-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/OriginLatencyTcpList.vue